module.exports = __webpack_public_path__ + "img/arrow_forward.9ecdebd3.svg";